import * as React from "react";
import { connect } from "react-redux";
import { FileBrowserFilesContext, IncomingFileBrowserHeadersContext, } from "../contexts";
import { getPathFromHeader } from "./utils";
import { withContext } from "../contexts/withContext";
import { ItemStatus } from "../entities";
import { FileBrowserFileManager } from "./FileBrowserFileManager";
export class _IncomingFileBrowserContainer extends React.Component {
    constructor(props) {
        super(props);
        this.clickedLocation = (i) => {
            this.setState({
                selectedLocation: i,
            });
            if (typeof this.props.header.locations !== "undefined") {
                this.props.fetchFiles({
                    relLocation: this.props.header.locations[i].relativeLocation,
                });
            }
        };
        this.state = {
            header: this.props.header
                ? this.props.header
                : { locations: [], extensions: [] },
            relLocation: "",
            selectedLocation: 0,
            loaded: false,
        };
    }
    componentDidMount() {
        this.props.fetchHeader({
            scenario: this.props.scenario,
            workspace: this.props.workspace,
        });
    }
    componentDidUpdate() {
        if (this.props.headerStatus !== ItemStatus.PENDING &&
            this.props.isDialogOpen &&
            !this.state.loaded &&
            typeof this.props.header.locations !== "undefined") {
            let location = 0;
            if (this.props.currentPath) {
                const path = this.props.currentPath;
                const locations = this.props.header.locations;
                for (let i = 0; i < locations.length; i++) {
                    const locationPath = locations[i].relativeLocation;
                    if (path.startsWith(locationPath)) {
                        location = i;
                        break;
                    }
                }
            }
            this.props.fetchFiles({
                relLocation: this.props.header.locations[location].relativeLocation,
            });
            this.setState({
                loaded: true,
                selectedLocation: location,
            });
        }
        else if (!this.props.isDialogOpen && this.state.loaded) {
            this.setState({
                loaded: false,
            });
        }
    }
    render() {
        const path = getPathFromHeader(this.props.currentPath, this.state.selectedLocation, this.props.header);
        return (React.createElement(FileBrowserFileManager, { isDialogOpen: this.props.isDialogOpen, currentPath: path, header: this.props.header, headerStatus: this.props.headerStatus, headerError: this.props.headerError, selectedLocation: this.state.selectedLocation, onClickedLocation: this.clickedLocation, onAccept: this.props.onAccept, onCancel: this.props.onCancel }));
    }
}
const mapStateToProps = (state, { __filebrowserheader }) => {
    const scenario = state.scenarios.scenarioName;
    const workspace = state.scenarios.workspaceName;
    let headerFetched = __filebrowserheader.selectors.getItem(state.incomingFileBrowserHeaders, {
        scenario: scenario,
        workspace: workspace,
    });
    return {
        scenario,
        workspace,
        header: headerFetched,
        headerStatus: __filebrowserheader.selectors.getStatus(state.incomingFileBrowserHeaders, {
            scenario,
            workspace,
        }),
        headerError: __filebrowserheader.selectors.getItemError(state.incomingFileBrowserHeaders, {
            scenario,
            workspace,
        }),
    };
};
const mapDispatchToProps = (dispatch, { __filebrowserheader, __filebrowseritems }) => {
    return {
        fetchHeader: (payload) => dispatch(__filebrowserheader.actions.fetchItem(payload)),
        fetchFiles: (payload) => dispatch(__filebrowseritems.actions.fetchItem(payload)),
    };
};
const Connected = connect(mapStateToProps, mapDispatchToProps)(_IncomingFileBrowserContainer);
const contextConfig = {
    __filebrowserheader: IncomingFileBrowserHeadersContext,
    __filebrowseritems: FileBrowserFilesContext,
};
export const IncomingFileBrowserContainer = withContext(contextConfig)(Connected);
//# sourceMappingURL=IncomingFileBrowserContainer.js.map